import cusatImg from '../../assets/png/cusat.png'
import fossGecImg from '../../assets/png/foss-GEC.png'
import netxImg from '../../assets/png/NetX-MACE.png'
import ieeeImg from '../../assets/png/ieee.png'
import fisatImg from '../../assets/jpg/fisat.jpg'

export const collegeData = [
    {
        id: 1,
        name: 'CUSAT',
        url: '',
        logo: cusatImg
    },
    {
        id: 2,
        name: 'FOSS CELL GECT',
        url: '',
        logo: fossGecImg
    },
    {
        id: 3,
        name: 'NetX | MACE',
        url: '',
        logo: netxImg
    },
    {
        id: 4,
        name: 'IEEE SSET SB',
        url: '',
        logo: ieeeImg
    },
    {
        id: 5,
        name: 'Icefoss FISAT',
        url: '',
        logo: fisatImg
    },
]